import { render, staticRenderFns } from "./GoodDetailBulkCategoryDialog.vue?vue&type=template&id=3806ad32"
import script from "./GoodDetailBulkCategoryDialog.vue?vue&type=script&lang=js"
export * from "./GoodDetailBulkCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./GoodDetailBulkCategoryDialog.vue?vue&type=style&index=0&id=3806ad32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports